import script from "./newModal.vue?vue&type=script&setup=true&lang=js"
export * from "./newModal.vue?vue&type=script&setup=true&lang=js"

import "./newModal.vue?vue&type=style&index=0&id=de9c4974&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de9c4974"]])

export default __exports__